<template>
  <el-dialog title="订购服务到期提醒" :visible.sync="dialogVisible" width="424px">
    <p class="text">
      {{ expireHint[0] }}
      <template v-if="expireHint[1]">
        <span class="day">{{ residueDay }}</span>{{ expireHint[1] }}
      </template>
    </p>
    <div class="content">
      <el-image :src="qrCode"></el-image>
      <div class="hint">打开微信扫一扫</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'expireDialog',
  props: {
    expireHint: {
      type: Array,
      default: _ => []
    },
    residueDay: {
      type: [String,Number],
      default: ''
    },
    qrCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.text {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  padding-left: 4px;
  .day {
    font-weight: bold;
    color: #FA8F14;
  }
}
.content {
  text-align: center;
  margin-top: 28px;
  .el-image {
    width: 240px;
    height: 240px;
  }
  .hint {
    margin-top: 16px;
    color: #666;
    font-size: 14px;
    margin-bottom: 8px;
  }
}
</style>
